import { render } from "./ViewCandidatesList.vue?vue&type=template&id=33c27415"
import script from "./ViewCandidatesList.vue?vue&type=script&lang=js"
export * from "./ViewCandidatesList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__